import LoginPageContent from "@user-management-context/primary/user/login/login.container";

export const LoginPage = () => {
  return <LoginPageContent />;
};
